<!-- banner 加入我们 -->
<template>
  <div v-if="status==='1'" class="banner h-[694px]" :style="`background:url(${bgUrl}) no-repeat;background-position: center top;`">
    <div class="container-1600 relative">
      <div class="absolute left-[44%] top-[350px]">
        <span class="group mt-[52px] inline-block rounded-[29px] px-[29px] transition-shadow hover:shadow-lg" style="background-color: #fff;">
          <!-- 如果是外链 -->
          <a v-if="recruitCateUrl.indexOf('http') !== -1" :href="recruitCateUrl" target="_blank">
            <div class="flex h-[46px] items-center" :style="`color: ${color};`">
              加入我们
              <Icon
                icon="bi:arrow-right"
                class="ml-[12px] inline-block text-[25px] transition-all group-hover:ml-[20px]"
              />
            </div>
          </a>
          <!-- 如果是当前网站链接 -->
          <router-link v-else :to="recruitCateUrl">
            <div class="flex h-[46px] items-center" :style="`color: ${color};`">
              加入我们
              <Icon
                icon="bi:arrow-right"
                class="ml-[12px] inline-block text-[25px] transition-all group-hover:ml-[20px]"
              />
            </div>
          </router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue2';

export default {
  name: 'BannerJoinUs',
  components: {
    Icon,
  },
  props: {
    to: {
      type: String,
      default: '', // 默认跳转社会招聘外链
    },
    bg: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#32a5a1',
    },
    status: {
      type: String,
      default: "1", // 是否展示banner
    },
  },
  computed: {
    recruitCateUrl() {
      if (this.to) {
        return this.to;
      } else {
        return this.$store.state.recruitCate[0].url;
      }
    },
    bgUrl() {
      if (this.bg.indexOf('http') === 0) {
        return this.bg;
      } else {
        return this.$getImageSrc(this.bg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  background-position: center;
  box-shadow: inset 0px 3px 9px -4px #787878;
}
</style>
